import { Component } from '@angular/core';

@Component({
  selector: 'app-report-selector',
  templateUrl: './report-selector.component.html',
  styleUrl: './report-selector.component.scss'
})
export class ReportSelectorComponent {

}
